import { EnumUserStatus } from "src/types/common-enum";

export const isDeletedUserStatus = (userStatus: EnumUserStatus) =>
    userStatus === EnumUserStatus.DeletionRequested || userStatus === EnumUserStatus.Deleted;
